import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/react-hooks';
import { getOr } from 'lodash/fp';
import { CREATE_CATEGORY } from '../../GraphQL/Mutations';
import useFormParams from '../../Hooks/useFormParams';
import useGraphQLErrorExtractor from '../../Hooks/useGraphQLErrorExtractor';
import useHeaderComponentsMutation from '../../Hooks/useHeaderComponentsMutation';
import GenericAlert from '../../Components/GenericAlert';
import useCurrentUser from '../../Hooks/userCurrentUser';
import useUpdateCategoriesCache from '../../Hooks/useUpdateCategoriesCache';
import useUserPermissionChecker from '../../Hooks/userUserPermissionChecker';
import Form from './Form';

const CategoryNew = () => {
  const history = useHistory();
  const { currentUser } = useCurrentUser(true);
  const checkPermission = useUserPermissionChecker(currentUser);
  const updateCache = useUpdateCategoriesCache(getOr(0, 'tenantId', currentUser));
  const [createCategory, { loading, error }] = useMutation(
    CREATE_CATEGORY,
    {
      onCompleted: (data) => {
        updateCache(data.createCategory.category);
        history.goBack();
      },
    },
  );
  useHeaderComponentsMutation({
    backLink: '/categories',
    title: 'categories',
  });
  const { params, onChange } = useFormParams({
    title: '',
  });
  const extractError = useGraphQLErrorExtractor();

  const onSubmit = (e) => {
    e.preventDefault();
    createCategory({
      variables: {
        ...params,
        tenantId: currentUser.tenantId,
      },
    });
  };

  useEffect(() => {
    if (currentUser) {
      if (checkPermission('Add Category') === undefined) {
        history.push('/categories');
      }
    }
  }, [currentUser, checkPermission, history]);

  return (
    <>
      <div className="row align-items-center">
        <div className="col-12 mx-auto px-4">
          {error ? <GenericAlert>{extractError(error)}</GenericAlert> : null}
          <Form
            onSubmit={onSubmit}
            onChange={onChange}
            params={params}
            loading={loading}
            currentUser={currentUser}
          />
        </div>
      </div>
      <hr />
    </>
  );
};
export default CategoryNew;
